import React from 'react';
import MeListItem from './item';
import {useMeList} from './hooks';
import GiftModal from './me-gift';
import Contact from './contact';
import {useGoTo} from '../me-header/hooks';

const MeList = () => {
  const {login} = useGoTo();
  const {
    list,
    renderLanguageModal,
    renderVersionModal,
    giftModalRef,
    renderConfirmModal,
    handleLogoutButton,
    t,
  } = useMeList();

  return (
    <div className="relative z-[1] px-3 pb-3">
      <div className="list-card">
        {list.map((item, index) => (
          <MeListItem key={index} {...item} />
        ))}
      </div>
      <Contact />
      {login && (
        <div
          className="mb-5 mt-5 flex h-12 cursor-pointer items-center justify-center rounded-lg bg-c1 text-sm font-medium text-white"
          onClick={handleLogoutButton}>
          {t('me.bottom.logout')}
        </div>
      )}
      {renderConfirmModal}
      {renderLanguageModal}
      {renderVersionModal}
      <GiftModal ref={giftModalRef} />
    </div>
  );
};

export default MeList;
